'use client';

import { c as _c } from "react/compiler-runtime";
import Text from '@/app/cc/_component/ui/common/Text/Text';
import styles from '@/app/cc/_component/ui/section/Differences/Differences.module.scss';
import DifferencesTable from '@/app/cc/_component/ui/section/Differences/DifferencesTable';
import Usagecalculator from '@/app/cc/_component/ui/section/Differences/UsageCalculator';
import { useGetDealType } from '@/app/cc/_stores/useDealTypeStore';
export default function Differences() {
  const $ = _c(11);
  const dealType = useGetDealType();
  let t0;
  if ($[0] !== dealType) {
    t0 = dealType === "rent" && <div className={styles.inner}><div className={styles.content}><div className={styles.title}><div className={styles.titleContent}><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">보증보험과는<br className="break" /> 무엇이 다른가요?</Text></div><Text as="p" category="body" variant="r1" color="var(--color-gray-700)">안심케어는 보증보험의 빈틈을 메우는 <b>필수 보완재</b> 입니다.</Text></div><DifferencesTable /></div></div>;
    $[0] = dealType;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  let t2;
  if ($[2] !== dealType) {
    t1 = <Usagecalculator dealType={dealType} />;
    t2 = dealType === "sale" && <div className={styles.saleTitle}><Text as="h3" category="display" variant="eb2" color="var(--color-gray-900)">내 안심케어<br />이용료는?</Text></div>;
    $[2] = dealType;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={styles.calculatorInner}>{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t3) {
    t4 = <section className={styles.differences}>{t0}{t3}</section>;
    $[8] = t0;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}